// Canonical zh-Hant labels for `WishBlock.block_type`.
//
// AGENTS.md §3 #14: every user-facing string must be Traditional Chinese, and
// §3 #13 says reuse before create. Several surfaces used to print the raw
// enum straight into the UI — `notes`, `checklist`, `progress`, `budget`,
// `link`, `photo` — which leaked English into an otherwise zh-Hant product
// (visible on the mobile wish detail header). This module is the single
// source; `LayoutEditor`'s add-block chips import from here too rather than
// keeping a second copy.

export const BLOCK_TYPE_LABELS: Record<string, string> = {
  progress: "進度（金額 / 百分）",
  budget: "預算",
  checklist: "待辦清單",
  photo: "照片 grid",
  link: "連結清單",
  notes: "備忘",
};

/** Addable block types, in the order the layout editor offers them. */
export const ADDABLE_BLOCK_TYPES = [
  { value: "progress" as const, label: BLOCK_TYPE_LABELS.progress },
  { value: "budget" as const, label: BLOCK_TYPE_LABELS.budget },
  { value: "checklist" as const, label: BLOCK_TYPE_LABELS.checklist },
  { value: "photo" as const, label: BLOCK_TYPE_LABELS.photo },
  { value: "link" as const, label: BLOCK_TYPE_LABELS.link },
  { value: "notes" as const, label: BLOCK_TYPE_LABELS.notes },
];

/** Human label for a block type; falls back to the raw value for unknown keys. */
export function blockTypeLabel(blockType: string): string {
  return BLOCK_TYPE_LABELS[blockType] ?? blockType;
}
